<template lang="pug">
.document-section(v-if="items && items.length")
  .headers
    .header.selected Documents
  .documents(@drop.prevent="drop")
    .document(v-for="(did, index) in items",
              @mouseenter.once="fetchOne(did)",
              :class="{ 'drop-target': editable && index === dropBefore, editing, 'has-pages': loadedPages[did] }")
      .bg(v-if="editing",
          :id="`d|${ did }`",
          :index="index",
          :draggable="editing",
          @dragstart="start",
          @dragover.prevent="docOver(did)",
          :style="{ 'background-image': `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ did }-1.png')` }")
        .has(v-if="insightDocs[did] || loadedPages[did]")
          .insights-info(v-if="insightDocs[did]")
            b {{ insightDocs[did].insights.length }}
            | &nbsp;insights
          .and(v-if="loadedPages[did] && insightDocs[did]") &nbsp;and&nbsp;
          .pages-info(v-if="loadedPages[did]")
            b {{ loadedPages[did].length }}
            | &nbsp; pages
          .text included
        zoomer(for="zoomedDoc", :value="{ did }", v-if="insightDocs[did] || loadedPages[did]")
        .delete(@click.stop="deleteDocument(did)", :title="`Remove ${ meta(did) && meta(did).t }`")
      a.bg(v-else,
           :style="{ 'background-image': `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ did }-1.png')` }",
           :href="`?rl=[${ items.join(',') }];rli=${ index }`",
           target="_blank")
        .has(v-if="insightDocs[did] || loadedPages[did]")
          .insights-info(v-if="insightDocs[did]")
            b {{ insightDocs[did].insights.length }}
            | &nbsp;insights
          .and(v-if="loadedPages[did] && insightDocs[did]") &nbsp;and&nbsp;
          .pages-info(v-if="loadedPages[did]")
            b {{ loadedPages[did].length }}
            | &nbsp; pages
          .text included
        zoomer(for="zoomedDoc", :value="{ did }", v-if="insightDocs[did] || loadedPages[did]")
      .info
        .title(v-if="meta(did).t", :title="meta(did).t") {{ meta(did).t }}
        .published
          .source-image(:title="meta(did).st", :style="{ 'background-image': meta(did).simgu && `url('${ meta(did).simgu }')` }")
          .date(v-if="meta(did).dpa") {{ prettyDate(meta(did).dpa) }}
          .page-count(v-if="meta(did).pgc") {{ meta(did).pgc }} pages
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed, moveOrAdd, prettyDate } from '@/helpers';
export default {
  name: 'documents',
  props: {
    documents: Array,
    dids: Array,
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    //...mapGetters(['docoSmallCache', 'zoomedInsights', 'allDids', 'loadedPages']),
    ...mapGetters(['docoSmallCache', 'zoomedInsights', 'allDids']),
    ...mapGetters('insightsNS', ['cheatsheet', 'insights']),
    ...vuexComputed('lazyLevel', 'sharing', 'dragType', 'dropBefore', 'loadedDocuments', 'popupOpen'),
    editing() {
      const { editable, $store: { getters } } = this;
      return editable && getters.editing;
    },
    feeds() {
      return this.loadedFeeds;
    },
    insightDocs() {
      const { cheatsheet: { documents }, documents: docs } = this;
      return documents || docs;
    },
    items() {
      const { dids, allDids } = this;
      return dids || allDids;
    },
    loadedPages() {
      const { dids, documents, $store: { getters: { loadedPages } } } = this;
      return dids && documents || loadedPages;
     }
  },
  methods: {
    ...mapActions(['deleteDocument']),
    prettyDate,
    meta(did) {
      return this.docoSmallCache[did] || {};
    },
    start({ dataTransfer, target: { id }, target, preventDefault }) {
      const stripper = /^([dvpit])\|/;
      const chararcter = (stripper.exec(id) || [])[1];
      console.log('chararcter', chararcter);
      const { playlist } = this;
      const actions = {
        v() {
          const [vid] = playlist?.filter(vid => vid.id === id.replace(stripper, '')) || [];
          if (vid) {
            dataTransfer.setData('text/plain', 'v|' + JSON.stringify(vid));
            //this.editingReadingList = false;
            //this.dragType = 'video';
          } else {
            // this is throwing
            //preventDefault();
          }
        }
      };
      actions.d = actions.i = actions.t = actions.p = setId;
      (actions[chararcter] || actions.v)();
      function setId() {
        dataTransfer.setData('text/plain', id);
      }
    },
    docOver(id) {
      const { documents } = this;
      const index = documents.indexOf(id);
      this.dropBefore = index;
      this.dragType = 'document';
      // const [dropBeforeVid] = playlist?.filter(v => v.id === id) || [];
    },
    drop(e) {
      const { dropBefore: to, playlist, dragType } = this;
      const { dataTransfer } = e;
      const data = dataTransfer.getData('text/plain');
      const stripper = /^([dvpit])\|/;
      const stripped = (data || '').replace(stripper, '');
      const character = (stripper.exec(data) || [])[1];
      const kind = ({ d: 'document', v: 'video', p: 'page', i: 'insight', t: 'tweet' })[character];
      console.log('drop kind', character, kind, dragType, data, stripped);
      if (kind === 'document' && dragType === 'document') {
        const id = stripped;
        // todo: change this to use documents with out modifying a prop
        const { dropBefore: to, loadedDocuments } = this;
        //const to = documents.indexOf(dropBefore);
        moveOrAdd(loadedDocuments, to, id);// && (this.loadedDocuments = loadedDocuments);
      } else {
        console.log('wrong drag type, was', dragType || 'null', 'expected video, document, or page');
      }
      this.dropBefore = null;
    },
    // todo: move this to the store
    async fetchOne(did) {
      const { docoSmallCache, $store: { commit } } = this;
      let json = docoSmallCache[did];
      console.log('fetching?', did, json);
      if (!json) {
        const response = await fetch(
          `https://d1l6gufwe1p5x2.cloudfront.net/api/topoqa/getdocsummarybyid?id=${ did }`
        );
        json = await response.json();
        const { Result: results, Message: message = 'small doco no results' } = json || {};
        if (results) {
          commit('smallDoco', { did, json: Object.freeze(results) });
        } else {
          console.log('small doco message', message);
        }
      }
      // dsc[did] = dsc[did] || json;
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.document-section {
  margin-top: 2rem;
  padding: 1rem;
  .headers {
    background-color: white;
  }
  .documents {
    display: grid;
    grid-template-columns: repeat(3, 33%);
    .document {
      color: inherit;
      position: relative;
      margin: 5%;
      margin-bottom: 5rem;
      padding-top: 116.25%;
      will-change: transform;
      transition: transform 250ms ease-in-out;
      z-index: 1;
      &:not(.editing):hover {
        transform: scale(1.05);
        & > .info {
          transform: scale(0.95);
        }
      }
      &.drop-target {
        transform: translate3d(1.5rem, 0, 0);
        &::before {
          content: '\00a0';
          position: absolute;
          top: 0;
          left: -1rem;
          height: 100%;
          width: 0.25rem;
          background-color: $brn;
        }
      }
      &.has-pages {
        & > .bg {
          .has {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 1rem;
            background-color: #f4f4f4;
            border: 1px solid #e7e7e7;
            border-left-width: 0;
            border-right-width: 0;
            padding: 0.25rem;
            color: $brn;
            font-weight: 200;
            display: flex;
            justify-content: space-evenly;
            font-size: 0.8rem;
            b {
              font-weight: 400;
            }
            .pages-info {

            }
          }
        }
      }
      & > .bg {
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
        width: 100%;
        padding-top: 129%;
        color: inherit;
        text-decoration: inherit;
        background: no-repeat center;
        background-size: contain;
        box-shadow: 0 0 5px #989898, 0 0 15px #989898;
      }
      & > .info {
        pointer-events: none;
        position: absolute;
        left: 1.5rem;
        width: calc(100% - 3rem);
        top: 100%;
        //margin-top: 0.125rem;
        z-index: -1;
        box-sizing: border-box;
        padding: 0.5rem;
        border: 1px solid #e7e7e7;
        border-top-color: transparent;
        border-bottom-right-radius: 3px;
        border-bottom-left-radius: 3px;
        background-color: #f4f4f4;
        will-change: transform;
        transition: transform 250ms ease-in-out;
        transform-origin: top center;
        .title {
          @include pubTitle;
          text-align: left;
          margin-bottom: 0.5rem;
        }
        .page-count {
          position: absolute;
          bottom: 1rem;
          right: 0.75rem;
          //color: #dadada;
          font-weight: 200;
        }
      }
    }
  }
}
</style>
